module.exports = __webpack_public_path__ + "img/image_8.8dd012a1.jpg";